// Vuex
import store from "@/store/index.js";

function checkExistsInfoUser() {
	let userInfo = store.state.user.user;

	if (!userInfo) {

		window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.sessionStorage.getItem('sipac_token');
		return axios.get("/api/user")
			.then((response) => {
				if(response && response.data && response.data.user){
					store.commit("setUser", response.data.user);
				}

				return true;

			}).catch((error) => {
				console.log("checkExistsInfoUser:", error);
				return Promise.reject(error);
			});

	} else {
		return true;
	}

}

function checkPermission(system, ...permission) {

    let check = false;
    if(window.sessionStorage.getItem('user')){
        let user =  window.sessionStorage.getItem('user');
        user = JSON.parse(user);
        let permissionArray = store.state.user.roles;

        if (permissionArray && permissionArray.length > 0 && system) {
            permission.forEach((item)=>{
                permissionArray.forEach((item2) => {

                    if (item2 == item) {
                        check = true;
                    }
                });
            });
        }
    }

    return check;
}

function checkProfile() {


}


export default {
	checkExistsInfoUser,
    checkPermission,
};

